// extracted by mini-css-extract-plugin
module.exports = {"hint":"InvitationAccept_hint__25q_b"};